import { c as _c } from "react/compiler-runtime";
import { getOrgVendorIntegrationsOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
const useVendorIntegrations = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getOrgVendorIntegrationsOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data,
    isLoading
  } = useQuery(t0);
  let t1;
  if ($[1] !== data) {
    t1 = (data ?? []).filter(_temp).sort(_temp2);
    $[1] = data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const integrations = t1;
  let t2;
  if ($[3] !== integrations || $[4] !== isLoading) {
    t2 = {
      integrations,
      isLoading
    };
    $[3] = integrations;
    $[4] = isLoading;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default useVendorIntegrations;
function _temp(integration) {
  return !integration.isLocked && (integration.isFootprintManaged || integration.id);
}
function _temp2(a, b) {
  return a.name.localeCompare(b.name);
}